export default "__VITE_ASSET__CbYqlUkj__"